import React, { createContext, useContext, useMemo, useState } from "react";
import { useSelectState } from "shared/hooks";
import { useErrors } from "common/hooks";

import dayjs from "dayjs";

import { FilterFormContext as Context, FilterFormErrorKeys, FilterFormProviderProps } from "./types";

const FilterFormContext = createContext({} as Context);
export const useFilterFormContext = () => useContext(FilterFormContext);

const firstDayOfCurrentMonth = dayjs().add(-1, 'day').set('hour', 0).set('minute', 0).set('second', 0).format();
const currentDate = dayjs().format();

export const FilterFormProvider = (props: FilterFormProviderProps) => {
  const [filterFormErrors, setFilterFormErrors, resetFilterFormErrorField] =
    useErrors<FilterFormErrorKeys>();
  const [autoObuNumber, changeAutoObuNumber, setAutoObuNumber] = useSelectState();
  const [defaultStartDay] = useState(firstDayOfCurrentMonth);
  const [startDate, setStartDate] = useState<Context["startDate"]>(
    firstDayOfCurrentMonth
  );
  const [defaultEndDay] = useState(currentDate);
  const [endDate, setEndDate] = useState<Context["endDate"]>(currentDate);

  const value = useMemo(
    () => ({
      filterFormErrors,
      setFilterFormErrors,
      resetFilterFormErrorField,

      autoObuNumber,
      setAutoObuNumber,
      changeAutoObuNumber,

      defaultStartDay,
      startDate,
      setStartDate,

      defaultEndDay,
      endDate,
      setEndDate,
    }),
    [
      filterFormErrors,
      setFilterFormErrors,
      resetFilterFormErrorField,

      autoObuNumber,
      setAutoObuNumber,
      changeAutoObuNumber,

      defaultStartDay,
      startDate,
      setStartDate,

      defaultEndDay,
      endDate,
      setEndDate,
    ]
  );

  return (
    <FilterFormContext.Provider value={value}>
      {props.children}
    </FilterFormContext.Provider>
  );
};
